import React from 'react';
import WorkflowAddRuleSection from '../../../sections/AdminDashboard/Configuration/WorkflowAddRule';

const WorkflowAddRule = () => {
  return <WorkflowAddRuleSection />;
};

export default WorkflowAddRule;
